<script setup>
import { computed, ref } from 'vue';

import Base from './FileUpload/Base.vue';
import Progress from './FileUpload/Progress.vue';
import { uploads } from '@/services/upload';

const props = defineProps({
    deleteable: {
        type: Boolean,
        default: true,
    },
    circular: {
        type: Boolean,
        default: true,
    },
});

const parent = ref();
const upload =  computed(() => {
    const file = parent.value?.files[0];

    if (!file) return null;

    return file.__client?.upload_id ? uploads[file.__client.upload_id] : null;
});
</script>

<template>
    <Base ref="parent" :accept="['image']" :multiple="false">
        <div v-if="parent" class="size-40" :class="{
            'rounded-full': circular,
            'rounded-md': !circular
        }">
            <div v-if="!parent.files[0]" class="size-full flex items-center justify-center border border-white-foreground/10 rounded-[inherit]">
                <app-icon-button :disabled="parent.field.disabled" icon="camera-add" @click="parent.selectFile()" />
            </div>
            <div v-else class="size-full rounded-[inherit] relative flex items-center justify-center border border-white-foreground/10 bg-[#131313]">
                <img class="select-none pointer-events-none rounded-[inherit] object-cover w-full h-full" :src="parent.files[0].url" />

                <div v-if="parent.files[0] && upload" class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
                    <Progress :upload="upload" />
                </div>

                <div class="absolute bottom-0 z-10">
                    <app-icon-button :disabled="parent.field.disabled" @click="parent.removeFile(parent.files[0].id)" icon="cancel-bold" xs button-style="filled" color="danger" />
                </div>
            </div>
        </div>
    </Base>
</template>
